import { render, staticRenderFns } from "./Nav.vue?vue&type=template&id=2e96ef6a&scoped=true&"
import script from "./Nav.vue?vue&type=script&lang=ts&"
export * from "./Nav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e96ef6a",
  null
  
)

export default component.exports